// extracted by mini-css-extract-plugin
export default {"pillInput":"I9NrCa0oRvla7HylIcil","input":"iyNmheZB0U1XOnaUNahZ","largerInput":"ECjXBoeonunVLcuCtLPN"};